module.exports = __webpack_public_path__ + "static/media/hero-s.53a28de8.jpg";